export const engagementAppGroupIdGetSpamClientDescriptions =
  "/engagement/:app_group_id/get_spam_client_descriptions";
